import { render, staticRenderFns } from "./ReguaView.vue?vue&type=template&id=6f270439"
import script from "./ReguaView.vue?vue&type=script&lang=js"
export * from "./ReguaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports